"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _Interactions = require("customer-data-communicator/schema/communicator/interaction/Interactions");

var _InteractionRecord = _interopRequireDefault(require("customer-data-objects/interaction/InteractionRecord"));

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var _CommunicatorActions = require("customer-data-communicator/data/communicator/actions/CommunicatorActions");

/*
  Adds initial content support to an interaction.  The content is provided via the `initialInteraction` prop.
*/
var propTypes = {
  children: _react.PropTypes.node,
  descriptor: _react.PropTypes.instanceOf(_InteractionDescriptorRecord.default).isRequired,
  initialInteraction: _react.PropTypes.instanceOf(_InteractionRecord.default),
  interaction: _react.PropTypes.instanceOf(_InteractionRecord.default)
};

var _default = function _default(InteractionComponent) {
  var InteractionWithInitialContent =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(InteractionWithInitialContent, _Component);

    function InteractionWithInitialContent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, InteractionWithInitialContent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithInitialContent).call(this, props));
      var initialInteraction = props.initialInteraction,
          type = props.descriptor.type;
      _this.state = {
        initialInteraction: initialInteraction
      };

      if (initialInteraction) {
        (0, _CommunicatorActions.clearInitialContent)(type);
      }

      return _this;
    }

    (0, _createClass2.default)(InteractionWithInitialContent, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(newProps) {
        var initialInteraction = newProps.initialInteraction,
            type = newProps.descriptor.type;

        if (initialInteraction) {
          this.setState({
            initialInteraction: initialInteraction
          });
          (0, _CommunicatorActions.clearInitialContent)(type);
        }

        if ((0, _Interactions.isInteractionReset)(this.props.interaction, newProps.interaction)) {
          this.setState({
            initialInteraction: null
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var interaction = this.state.initialInteraction || this.props.interaction;
        return _react.default.createElement(InteractionComponent, (0, _extends2.default)({}, this.props, {
          interaction: interaction
        }), this.props.children);
      }
    }]);
    return InteractionWithInitialContent;
  }(_react.Component);

  InteractionWithInitialContent.propTypes = propTypes;
  return InteractionWithInitialContent;
};

exports.default = _default;
module.exports = exports.default;